// import { PartialRequired } from "../types/TCanvasHandler";
import { TCanvasNode } from "../types/TCanvasNode";
import { TCatalog } from "../types/TCatalog";
import createNodeId from "./createNodeId";

// export function parsePartialNodes(data: PartialRequired<TCatalog, "id">[]) {
//   return data.map(item => parsePartialNode(item))
// }
// export function parsePartialNode(item: PartialRequired<TCatalog, "id">): TCanvasNode {
//   return {
//     node_id: createNodeId(item.id, item.type),
//     node_type: item.type,
//     id: item.id,
//     name: item.name,
//     description: item.description,
//     parent_node_id: item.parent_id ? createNodeId(item.parent_id, item.type == 'TABLE' ? 'DOMAIN' : 'TABLE') : null,
//     payload: item.payload ? [item.payload] : [],
//   }
// }

export default function parseNodes(data: TCatalog[]): TCanvasNode[] {
  return data.map(item => parseNode(item))
}

export function parseNode(item: TCatalog): TCanvasNode {
  return {
    node_id: createNodeId(item.id, item.type),
    node_type: item.type,
    id: item.id,
    name: item.name,
    description: item.description,
    parent_node_id: item.parent_id ? createNodeId(item.parent_id, item.type == 'TABLE' ? 'DOMAIN' : 'TABLE') : null,
    payload: item.payload ? [item.payload] : [],
    shown: item.shown ?? false,
    highlight: null,
    color: item.payload?.color || null,
  }
}
